// Centralised date formatting. Display all dates in NZ format: DD/MM/YYYY.
// Use formatDate for date-only, formatDateTime for date + 24h time.

const pad = (n) => String(n).padStart(2, '0');

const toDate = (input) => {
  if (!input) return null;
  const d = input instanceof Date ? input : new Date(input);
  return isNaN(d.getTime()) ? null : d;
};

// DD/MM/YYYY
export const formatDate = (input) => {
  const d = toDate(input);
  if (!d) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

// DD/MM/YYYY HH:MM (24h)
export const formatDateTime = (input) => {
  const d = toDate(input);
  if (!d) return '';
  return `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Short DD/MM (no year) for compact contexts like chat timestamps
export const formatDateShort = (input) => {
  const d = toDate(input);
  if (!d) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
};

// HH:MM (24h) only — for time-of-day badges
export const formatTime = (input) => {
  const d = toDate(input);
  if (!d) return '';
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
